<template>
  <div id="signinDiv"></div>
</template>

<script>
export default {
  name: "GoogleSignInButton",
  props: {
    clientId: {
      type: String,
      required: true,
    },
    oneTap: {
      type: Boolean,
      default: false,
    },
    mode: {
      type: String,
      default: "signin",
    },
  },
  data() {
    return {
      scriptUrl: "https://accounts.google.com/gsi/client",
    };
  },
  watch: {
    oneTap(newValue, oldValue) {
      if (newValue !== oldValue) {
        if (newValue) {
          this.showPrompt();
        } else {
          this.renderButton();
        }
      }
    },
  },
  methods: {
    handleCredentialResponse(response) {
      const idToken = response.credential;
      const payload = JSON.parse(atob(idToken.split(".")[1]));
      const email = payload.email;
      this.$emit("onSuccess", { payload, idToken, email });
    },
    onClickHandler() {
      this.$emit("onClick");
    },
    showPrompt() {
      window.google.accounts.id.prompt((notification) => {
        if (notification.isNotDisplayed() || notification.isSkippedMoment()) {
          this.$emit("onPromptDismiss");
        }
      });
    },
    renderButton() {
      window.google.accounts.id.renderButton(
        document.getElementById("signinDiv"),
        {
          theme: "outline",
          size: "large",
          click_listener: this.onClickHandler,
        }
      );
    },
    loadGoogleIdentityService() {
      return new Promise((resolve) => {
        const scriptExists = document.querySelector(
          `script[src="${this.scriptUrl}"]`
        );
        const isButtonRendered = document
          .getElementById("signinDiv")
          .hasChildNodes();
        if (scriptExists) {
          if (!isButtonRendered) {
            this.initializeGoogleService();
          }
          resolve();
          return;
        }
        const scriptElement = document.createElement("script");
        scriptElement.src = this.scriptUrl;
        scriptElement.async = true;
        scriptElement.defer = true;
        scriptElement.onload = () => {
          this.initializeGoogleService();
          resolve();
        };
        document.body.appendChild(scriptElement);
      });
    },
    initializeGoogleService() {
      window.google.accounts.id.initialize({
        client_id: this.clientId,
        callback: this.handleCredentialResponse,
        ux_mode: "popup",
        context: this.mode,
        cancel_on_tap_outside: false,
      });
      if (this.oneTap) {
        this.showPrompt();
      } else {
        this.renderButton();
      }
    },
  },
  mounted() {
    this.loadGoogleIdentityService().then(() => {
      if (this.oneTap) {
        this.showPrompt();
      }
    });
  },
};
</script>
